import {CoreModel} from '../../model/CoreModel';
import CoreMessageDispatcher from '../../controller/CoreMessageDispatcher';
import CoreEvents from '../../events/CoreEvents';
import SoundEvents from '../../events/SoundEvents';
import LoadStory from '../load/LoadStory';
import {StoriesMap} from '../../../../stories/ImportStoriesToBuild';

const _sendCoreEvents = model => {
    const _dispatcher = CoreMessageDispatcher.instance();

    if (model.currentEventExpandedChanged) {
        model.resetCurrentEventExpandedChanged();
        _dispatcher.emit(CoreEvents.CURRENT_EVENT_STATE_CHANGED);
    }

    if (model.currentEventOpenedChanged) {
        model.resetCurrentEventOpenedChanged();
        _dispatcher.emit(CoreEvents.CURRENT_EVENT_STATE_CHANGED);
    }

    if (model.stateChanged) {
        model.resetStateChanged();
        _dispatcher.emit(CoreEvents.MODEL_STATE_CHANGED);
        _dispatcher.emit(CoreEvents.MODEL_CHANGED);
    }

    if (model.menuOnChanged || model.menuAvailableChanged) {
        model.resetMenuOnChanged();
        model.resetMenuAvailableChanged();
        _dispatcher.emit(CoreEvents.MENU_STATE_CHANGED);
    }

    if (model.soundChannelStateChanged) {
        model.resetSoundChannelStateChanged();
        _dispatcher.emit(SoundEvents.CHANNEL_STATE_CHANGED);
    }
};

const GotoNewState = doThat => {
    return new Promise(resolve => {
        if (!doThat) {
            resolve(doThat);
            return;
        }

        const model = CoreModel.instance();
        const prevEventId = model.currentEventId;
        model.state = doThat;
        model.menuOn = false;
        const isChanged = model.stateChanged || model.currentEventOpenedChanged;

        if (model.currentEventId.length > 0 && prevEventId !== model.currentEventId) {
            // Check if pack is loaded:
            const src = StoriesMap[model.currentEventId];
            if (model.isPackReady(src)) {
                _sendCoreEvents(model);
                resolve(isChanged);
                return;
            }

            LoadStory(src, true).then(done => {
                // TODO: display message
                if (!done) return;

                _sendCoreEvents(model);
                resolve(isChanged);
            });
        } else {
            _sendCoreEvents(model);
            resolve(isChanged);
        }
    });
};

export {GotoNewState};
